import { render } from "./ContentView.vue?vue&type=template&id=1457868a&scoped=true"
import script from "./ContentView.vue?vue&type=script&lang=js"
export * from "./ContentView.vue?vue&type=script&lang=js"

import "./ContentView.vue?vue&type=style&index=0&id=1457868a&lang=scss&scoped=true"
import "./ContentView.vue?vue&type=style&index=1&id=1457868a&lang=scss&scoped=true"

import exportComponent from "E:\\_projekte\\PRIGNITZMUSEUM_HAVELBERG\\ARCHITEKTURSPUR\\release\\architekturspur\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1457868a"]])

export default __exports__